/** 리모컨 공지/질문 팝업·리모컨 모달 디자인: 시안 A(과제 체크형)로 확정 */
export const REMOTE_DESIGN_CLASS = 'cp-remote-theme-a';
